// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__29_qr","empty":"ModalGraph_empty__1NcdN"};